package io.jsonize.web.navigation

import androidx.compose.runtime.Composable
import androidx.compose.runtime.MutableState
import androidx.compose.runtime.collectAsState
import androidx.compose.runtime.getValue
import io.jsonize.web.screens.editor.EditorScreen
import io.jsonize.web.screens.SettingsScreen
import io.jsonize.web.screens.editor.EditorPanel
import io.jsonize.web.viewmodel.AppViewModel

@Composable
fun NavigationGraph(
    nav: NavController,
    vm: AppViewModel,
    editorPanelState: MutableState<EditorPanel>,
    lastContentPanelState: MutableState<EditorPanel>
) {
    val currentRoute by nav.current.collectAsState()
    when(currentRoute){
        is Route.Editor -> EditorScreen(
            nav = nav,
            appViewModel = vm,
            editorPanelState = editorPanelState,
            lastContentPanelState = lastContentPanelState
        )
        is Route.Settings -> SettingsScreen(nav = nav)
    }
}
